import { Divider, Typography, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@material-ui/core";
import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getDecks, updateHeaderInfo, copyDeck, getUserDetails, addNote } from "../actions";
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import Modal from '@material-ui/core/Modal';
import { isMobileOnly } from 'react-device-detect';
import "../styles/questionStyles.css";
import "../styles/masterStyles.css";
import { CopyrightWidget } from "../components";
import { deviceData, getThisYear, setActiveNavigationWidget } from "../common";
import { isBrowser, isElectron } from 'react-device-detect';

class NoteListScreen extends Component {
    state = {
        reload: false,
        copyModal: false,
        text: 'test...',
    }

    componentDidMount = async () => {
        setActiveNavigationWidget("inboxFooterIcon");

        await document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
        const { mcid, key } = this.props.auth_feedback;
        await this.props.getUserDetails( mcid, key, deviceData(this.props.location, 'navigate') );
        return this.props.updateHeaderInfo({
            route:"/myNotes", 
            name: "Note List", 
            iconTwo: 'menu',
            iconOne: 'home',
        });
    };

    componentDidUpdate = async (prevProps, prevState) => {        
        if (this.state.reload) {
            this.setState({ ...this.state, reload: false});
        }
    }

    handleOpen = () => {
        this.setState({
            ...this.state,
            copyModal: true,
        });
    };

    handleClose = () => {
        this.setState({
            ...this.state,
            copyModal: false,
        });
    };

    handleSubmit = async (obj) => {
        let data = {
            mcid: obj.mcid,
            key: obj.key
        }

        if (typeof obj.yearvar !== 'undefined') {
            data.yearvar = obj.yearvar;
            data.gameMode = this.props.gameMode;
        } else if (typeof obj.deckID !== 'undefined') { 
            data.deckID = obj.deckID;
        }

        switch(obj.type) {
            case 'note': {
                data.noteID = obj.noteID;
                data.state = obj.state;
                data.comment = obj.comment;

                await this.props.addNote(data);
                return this.props.getUserDetails(obj.mcid, obj.key);
            }

            default: {
                document.getElementById('root').scrollTo({top: 0, behavior: "smooth"});
                return null;
            }
        }
    }

    setColorObj = (type = 'base') => {
        let r;

        switch (type) {
            default: {
                r = {
                    deck: "neutralGreenCard",
                    text: "neutralGreenText",
                    button: "neutralGreenCard"
                }
            }
        }
        return r;
    }

    cleanText = (text) => {
        let r = '<p>' + text + '</p>';
        r = r.replace(/\n/g, '</p><p>');
        r = r.replace(/\r/g, '</p><p>');
        r = r.replace(/<\/p><p><\/p><p>/g, '</p><p>');
        r = r.replace(/\t/g, '');
        return r;
    }

    createMarkup = props => {
        let temp = props;
        if (!props.includes('<p>')) { temp = this.cleanText(temp); }
        return { __html: temp };
    };

    mapMyNotes = () => {
        const notes = this.props.user_details.notes.notes;

        if (typeof notes !== 'undefined' && notes.length > 0) {
            return notes.map((row, index) => {
                return (
                    <>
                        <TableRow key={'noteDeatils-' + row.qNumber}>
                            <TableCell 
                                style={{
                                    fontSize: "0.85rem",
                                    border: "none",
                                    padding: "16px 8px 0"
                                }} 
                                align="left" 
                                className="text-blue text-strong"
                            >
                                {isMobileOnly 
                                    ? (<>{row.qYear + 'Q' + row.qNumber}</>)
                                    : (<>{row.qYear + ' Question ' + row.qNumber}</>)
                                }
                                
                            </TableCell>

                            <TableCell
                                align="right" 
                                style={{
                                    fontSize: "0.75rem",
                                    width: "100px",
                                    border: "none",
                                    padding: "16px 8px 0"
                                }}
                            >
                                {row.dateStr}
                            </TableCell>
                            
                            <TableCell 
                                align="right" 
                                style={{
                                    border: "none",
                                    padding: "16px 0 0",
                                    width: "35px"
                                }}
                            >
                                <DeleteForeverIcon 
                                    className="text-orange"
                                    style={{fontSize: "1.15rem"}}
                                    onClick={() => this.handleSubmit({
                                        noteID:row.noteID,
                                        mcid: this.props.user_details.mcid,
                                        key: this.props.user_details.key,
                                        state: 0,
                                        comment: row.comment,
                                        type: 'note'
                                    })}
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow key={'noteComment-' + row.qNumber}>
                            <TableCell
                                style={{fontSize: "0.75em", padding: "0 8px"}} 
                                align="left" 
                                colSpan={3}
                            >
                                <div
                                    dangerouslySetInnerHTML={this.createMarkup(row.comment)}
                                ></div>
                            </TableCell>
                        </TableRow>
                    </>
                )
            });
        } else {
            return (
                <TableRow key={'note-error'}>
                    <TableCell
                        style={{fontSize: "0.75rem", padding: "0 8px"}} 
                        align="left" 
                        colSpan={3}
                    >
                        <p>
                            No Notes
                        </p>
                    </TableCell>
                </TableRow>
            );
        }
    };

    setContainer = (bool) => {
        return { padding: "0 16px 32px", margin: "calc(env(safe-area-inset-top) + 56px) 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 0px)", overflowY: "auto", backgroundColor: "white" };

        if (bool) {
            if (isBrowser && !isElectron) {
                return { padding: "16px 16px 32px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)", overflowY: "auto" };
            } else {
                return { padding: "16px 32px 32px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)", overflowY: "auto" };
            }
            
        } else {
            if (isBrowser && !isElectron) {
                return { padding: "16px 16px 32px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)", overflowY: "auto" };
            } else {
                return { padding: "16px 32px 32px", margin: "0 0 64px", width: "calc(100% - 32px)", height: "calc(100vh - 160px)", overflowY: "auto" };
            }
        }
    }

    render() {
        return (
            <>
                <div className="aua-overflow" style={this.setContainer(isBrowser)}>
                    <Typography className="homeDividerText">My Notes</Typography>

                    <div className="anchor" style={{margin:"8px 0 16px", width: "calc(100%)"}}>
                        <TableContainer class="margin-bottom-24"  component={Paper}>
                            <Table style={{width: "100%"}} aria-label="custom pagination table">
                                <TableBody style={{marginTop: "8px"}}>
                                    {this.mapMyNotes()}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>

                    <CopyrightWidget 
                        year={getThisYear()}
                        textAlign={'center'}
                        className="margin-top-16 padding-top-8 padding-bottom-24 padding-left-16 padding-right-16"
                    />
                </div>

                <Modal
                    open={this.state.copyModal}
                    onClose={this.handleClose}
                    aria-labelledby="copyModal-modal-title"
                    aria-describedby="copyModal-modal-description"
                    style={{
                        display:"flex",
                        flexDirection:"column",
                        justifyContent:"center",
                        alignItems:"center"
                    }}
                >
                    <div 
                        style={{
                            position: 'absolute',
                            backgroundColor: "#fff",
                            border: "2px solid #00567a",
                            borderRadius: "8px",
                            padding: "32px 16px",
                            maxHeight: `68vh`,
                            width: '75vw',
                            overflow: 'auto',
                            outline: "none"
                        }}
                    >
                        <div 
                            id="copyModal-modal-description" 
                            style={{fontSize: "1rem"}}
                        >
                            <div>
                                <p>You have copied <span className="text-blue">{this.state.text}</span>.</p>
                                <p>You can find the deck on your decks page.</p>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        );
    }
}

const mapStateToProps = state => {
    const { auth_feedback, user_details } = state.auth;
    const { headerText, iconOne, iconTwo, backgroundcolor } = state.style;
    const { deckList } = state.decks;
    return {
        headerText,
        iconOne,
        iconTwo,
        backgroundcolor,
        deckList,
        auth_feedback,
        user_details
    };
};

export default connect(mapStateToProps, 
    { 
        updateHeaderInfo, getDecks, copyDeck, getUserDetails, addNote
    })(withRouter(NoteListScreen));